import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

const CardList = ({ title, children }) => {
  return (
    <div className="food-card min-w-[310px] !bg-white px-6 pb-6 pt-4">
      <div className="">
        <div className="text-[12px] font-normal">Хоолны жагсаалт</div>

        <div className="mb-5 mt-1 rounded-md bg-btnGreen-normal px-3.5 py-1.5 text-[14px] font-semibold uppercase text-white shadow-md">
          {title}
        </div>

        {children}
      </div>
    </div>
  );
};

export const CardListItem = ({ food }) => {
  return (
    <div className="mt-2.5">
      <Link
        to={`details/${food.id}`}
        className="flex w-full items-center justify-between rounded-md border border-[#d3cfcf] py-1.5 pl-3 pr-2 text-[14px] hover:bg-sideBarGrey"
      >
        <div>{food.name}</div>
        <IoIosArrowForward color="#8E8E8E" />
      </Link>
    </div>
  );
};

export default CardList;
